import keyMirror from 'keymirror'

const ApplicationConstants = keyMirror({
  SET_LANGUAGES: null,
})

export default ApplicationConstants
